import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Header from "../components/header";
import Footer from "../components/footer";
import { Helmet } from "react-helmet-async";

const About = () => {

    const [categories, setCategories] = useState([]);
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [about, setAbout] = useState({});

    useEffect(() => {

        axios.get("https://kskrishnasilver.com/api/about.php")
            .then(res => {
                setAbout(res.data);
            });

    }, []);

    // Preloader timer
    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    /* ========================
    SCROLL DETECT
    ======================== */

    useEffect(() => {

        const handleScroll = () => {
            if (window.scrollY > 60) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);

    }, []);

    useEffect(() => {
        axios
            .get("https://kskrishnasilver.com/api/category.php")
            .then((res) => {
                console.log("API Response:", res.data);

                if (Array.isArray(res.data)) {
                    setCategories(res.data);
                } else if (res.data.data) {
                    setCategories(res.data.data);
                } else {
                    console.log("Unexpected format");
                }
            })
            .catch((err) => {
                console.error("Error fetching categories:", err);
            });
    }, []);


    return (

        <>
            {loading && (
                <div className="loader-wrapper">
                    <div className="ring-loader"></div>
                </div>
            )}
            <Header />
            <Helmet>
                <title>
                    {`About Us | Krishna Silver | ${process.env.REACT_APP_PHONE}`}
                </title>
            </Helmet>

            {/* <div className="collection-hero">
                <h1>About Us</h1>

                <div className="breadcrumb">
                    <Link to="/">Home</Link>
                    <span> ~ </span>
                    <span>About</span>
                </div>

            </div> */}

            <div className="collection-page">
                <div className="collection-hero">
                    <h1><Link to="/">Home</Link> <span> ~ </span> <Link className="activepage" to="/about">About Us</Link></h1>
                </div>
            </div>
            <section className="about">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 about-left">

                            <span className="subtitle">ABOUT US</span>

                            <h2>
                                Who We Are
                            </h2>

                            {/* <p>
                                Founded in 1995, Krishna Silver stands as India's premier destination for exceptional silver jewelry boasting stunningly intricate designs. Our mission is to transform the silver jewelry and lifestyle sector in India, prioritizing uncompromising quality and unparalleled customer satisfaction.
                            </p>

                            <p>With an extensive collection of over lots of unique designs across various categories, we offer unparalleled choices. Each design is meticulously crafted with utmost care, providing you with the flexibility to customize purity, color, and clarity to perfectly match your preferences.</p> */}
                            <div dangerouslySetInnerHTML={{__html:about.content}}></div>

                            {/* <button className="about-btn">Explore More</button> */}

                        </div>


                        <div className="col-lg-6 about-right">

                            <div className="about-image-box">
                                <img src={about.image}  alt="Krishna Silver Jewellery" className="about-main-img" />

                                <div className="image-bg-shape"></div>

                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default About;